// extracted by mini-css-extract-plugin
module.exports = {"header":"searchSnippet_header__q5llX","cards":"searchSnippet_cards__ryGkP"};